import React from 'react';
import PropTypes from 'prop-types';

function EventButton(props) {
  const { onSubmit, linktext } = props;
  return (
    <button
      type="button"
      onClick={onSubmit}
      className="bg-buttons-private rounded-md p-2 px-6 text-gray-300 xl:text-lg md:text-md text-sm font-300 hover:bg-private-link"
    >
      {linktext}
    </button>
  );
}

export default EventButton;

EventButton.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  linktext: PropTypes.string.isRequired,
};
